module.exports = __webpack_public_path__ + "img/clc_care-login.5de737b7.png";